import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { has } from '../services/helper';

/**
 * Types and Action Creators
 */
const { Types, Creators } = createActions({
    getCaravanRequest: ['identifier'],
    getCaravanSuccess: ['caravan'],
    getCaravanFailure: null,
    listCaravansRequest: null,
    listCaravansSuccess: ['caravans'],
    listCaravansFailure: null,
});

export const CaravanTypes = Types;
export default Creators;

/**
 * Initial State
 */
export const INITIAL_STATE = Immutable({
    identifier: null,
    caravans: null,
    caravan: null,
    fetching: null,
    error: null,
});

/**
 * Request the single caravan
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const getCaravanRequest = (state, action) =>
    state.merge({ fetching: true, identifier: action.identifier });

/**
 * Handle single caravan fetch success
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const getCaravanSuccess = (state, action) => {
    const { caravan } = action;

    return state.merge({
        fetching: false,
        error: null,
        caravans: [caravan.data],
        caravan: caravan.data.name,
    });
};

/**
 * Handle single caravan fetch failure
 *
 * @param {Object} state
 * @return {Object}
 */
export const getCaravanFailure = state =>
    state.merge({ fetching: false, error: true, identifier: null });

/**
 * Request the list of all caravans
 *
 * @param {Object} state
 * @return {Object}
 */
export const listCaravansRequest = state => state.merge({ fetching: true });

/**
 * A successful caravans lookup and merge the new data with the store.
 *
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export const listCaravansSuccess = (state, action) => {
    const { caravans } = action;
    const newState = {
        fetching: false,
        error: null,
    };

    if (has(caravans, 'data')) {
        newState.caravans = caravans.data;
    }

    return state.merge(newState);
};

/**
 * Failed to get the all caravans
 *
 * @param {Object} state
 * @return {Object}
 */
export const listCaravansFailure = (state) =>
    state.merge({ fetching: false, error: true });

/**
 *  Hookup Reducers To Types
 */
export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_CARAVAN_REQUEST]: getCaravanRequest,
    [Types.GET_CARAVAN_SUCCESS]: getCaravanSuccess,
    [Types.GET_CARAVAN_FAILURE]: getCaravanFailure,
    [Types.LIST_CARAVANS_REQUEST]: listCaravansRequest,
    [Types.LIST_CARAVANS_SUCCESS]: listCaravansSuccess,
    [Types.LIST_CARAVANS_FAILURE]: listCaravansFailure,
});
